import { Card, CardBody, Table } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { selectedSportAtom } from '../../atoms/selectedMetadata';
import {
  STATSBOMB_DATA_SOURCE,
  videoSearchMatchDataAtom,
} from '../../atoms/videoListings';
import { EMPTY_CELL_VALUE } from '../../constants/tableRows';
import CardHeader from '../CardHeader';
import CellHeadings from '../CellHeadings';
import { FOOTBALL_IDENTIFIER } from '../Sport/Sport';

export function StatsbombDataMatchInfo() {
  const intl = useIntl();
  const matchData = useAtomValue(videoSearchMatchDataAtom);
  const selectedSport = useAtomValue(selectedSportAtom);

  if (
    !matchData ||
    matchData.source !== STATSBOMB_DATA_SOURCE ||
    selectedSport !== FOOTBALL_IDENTIFIER
  ) {
    return null;
  }

  const headings = [
    {
      children: intl.formatMessage({
        defaultMessage: 'Home Team',
        id: '1fdd2',
      }),
      id: 'home-team',
    },
    {
      children: intl.formatMessage({
        defaultMessage: 'Away Team',
        id: 'f6add',
      }),
      id: 'away-team',
    },
    {
      children: intl.formatMessage({
        defaultMessage: 'Date',
        id: '44749',
      }),
      id: 'date',
    },
    {
      children: intl.formatMessage({
        defaultMessage: 'Stream Access Error Reasons',
        id: 'cc243',
      }),
      id: 'stream-access-error-reasons',
    },
    {
      children: intl.formatMessage({
        defaultMessage: 'GSL Match ID',
        id: '4427e',
      }),
      id: 'gsl-match-id',
    },
    {
      children: intl.formatMessage({
        defaultMessage: 'Statsbomb Data Match ID',
        id: '4183f',
      }),
      id: 'statsbomb-match-id',
    },
    {
      children: intl.formatMessage({
        defaultMessage: 'Streams Last Updated',
        id: '5b726',
      }),
      id: 'streams-last-updated',
    },
  ];

  return (
    <Card>
      <CardHeader>
        <FormattedMessage
          defaultMessage="Match Data"
          description="Match Data"
          id="0c8c6"
        />
      </CardHeader>
      <CardBody>
        <Table
          size="small"
          aria-label={intl.formatMessage({
            defaultMessage: 'Statsbomb match details',
            id: '19a4e',
          })}
        >
          <CellHeadings cells={headings} textAlign="left" />
          <Table.Body>
            <Table.Row>
              <Table.DataCell $textAlign="left">
                {matchData.home_team_name || EMPTY_CELL_VALUE}
              </Table.DataCell>
              <Table.DataCell $textAlign="left">
                {matchData.away_team_name || EMPTY_CELL_VALUE}
              </Table.DataCell>
              <Table.DataCell $textAlign="left" data-testid="match-data-date">
                {matchData.date
                  ? intl.formatDate(matchData.date, { timeZone: 'UTC' })
                  : EMPTY_CELL_VALUE}
              </Table.DataCell>
              <Table.DataCell
                $textAlign="left"
                data-testid="match-data-error-reason"
              >
                {matchData.error_reason || EMPTY_CELL_VALUE}
              </Table.DataCell>
              <Table.DataCell $textAlign="left">
                {matchData.gsl_match_id || EMPTY_CELL_VALUE}
              </Table.DataCell>
              <Table.DataCell $textAlign="left">
                {matchData.match_id || EMPTY_CELL_VALUE}
              </Table.DataCell>
              <Table.DataCell
                $textAlign="left"
                data-testid="match-data-streams-updated"
              >
                {matchData.streams_library_entries_updated
                  ? intl.formatTime(matchData.streams_library_entries_updated, {
                      day: 'numeric',
                      month: 'numeric',
                      year: 'numeric',
                    })
                  : EMPTY_CELL_VALUE}
              </Table.DataCell>
            </Table.Row>
          </Table.Body>
        </Table>
      </CardBody>
    </Card>
  );
}

export default { StatsbombDataMatchInfo };
